import { render } from "./PageHeader.vue?vue&type=template&id=42f1b155&scoped=true"
import script from "./PageHeader.vue?vue&type=script&lang=js"
export * from "./PageHeader.vue?vue&type=script&lang=js"

import "./PageHeader.vue?vue&type=style&index=0&id=42f1b155&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42f1b155"]])

export default __exports__